import { useContext, useEffect } from "react";
import { UNSAFE_NavigationContext as NavigationContext } from "react-router-dom";

export function useBlocker (blocker, when = true) {
  const { navigator } = useContext(NavigationContext);

  useEffect(() => {
    if (!when) return;

    const pushState = navigator.push;
    const replaceState = navigator.replace;

    navigator.push = (...args) => {
      blocker({
        action: "PUSH",
        location: args[0],
        retry: () => pushState.apply(navigator, args),
      });
    };

    navigator.replace = (...args) => {
      blocker({
        action: "REPLACE",
        location: args[0],
        retry: () => replaceState.apply(navigator, args),
      });
    };

    return () => {
      navigator.push = pushState;
      navigator.replace = replaceState;
    };
  }, [navigator, blocker, when]);
}